import * as React from 'react';
import { useLexicalComposerContext } from '@fluentui-copilot/react-text-editor';
import type { GhostTextProps } from '../../GhostText';
import { $createGhostTextNode, $isGhostTextNode } from '../../GhostText';
import type { IManualGhostTextBase } from '@fluentui-copilot/chat-input-plugins';
import { ManualGhostTextBase } from '@fluentui-copilot/chat-input-plugins';

export type ManualGhostTextProps = {
  id: string;
};

export type ManualGhostTextRef = IManualGhostTextBase<GhostTextProps>;

export const ManualGhostTextPlugin = React.forwardRef<ManualGhostTextRef, ManualGhostTextProps>((props, ref) => {
  const { id } = props;
  const [editor] = useLexicalComposerContext();

  React.useImperativeHandle<ManualGhostTextRef, ManualGhostTextRef>(
    ref,
    () => new ManualGhostTextBase(editor, id, $isGhostTextNode, $createGhostTextNode),
    [editor, id],
  );

  return null;
});

ManualGhostTextPlugin.displayName = 'ManualGhostTextPlugin';
